import BasicLayout from '@/layouts/Basic';
import {wrapModelLoaderAsBeforeRouterEnterHook} from '../lib/model';

const importEnv = require('./_import_' + process.env.NODE_ENV);

export default [
    {
        path: '/user/:userid/textCreate',
        name: 'textCreateWork',
        component: BasicLayout,
        meta: {
            onlyV1: true
        },
        children: [
            {
                path: '/',
                redirect: {
                    name: 'textCreateWork'
                }
            },
            {
                path: 'work',
                name: 'textCreateWork',
                meta: {
                    authorizedRole: 'digital_human_list'
                },
                component: importEnv('TextCreate/work/index')
            },
            {
                path: 'title/fc',
                name: 'textCreateFc',
                meta: {
                    source: 'fc',
                    authorizedRole: 'digital_human_list'
                },
                beforeEnter: wrapModelLoaderAsBeforeRouterEnterHook('TextCreate', () =>
                    import('../model/TextCreate')
                ),
                component: importEnv('TextCreate/create/AiContent')
            },
            {
                path: 'title/feed',
                name: 'textCreateFeed',
                meta: {
                    source: 'feed',
                    authorizedRole: 'digital_human_list'
                },
                beforeEnter: wrapModelLoaderAsBeforeRouterEnterHook('TextCreate', () =>
                    import('../model/TextCreate')
                ),
                component: importEnv('TextCreate/create/AiContent')
            },
            {
                path: 'script',
                name: 'textCreateScript',
                meta: {
                    source: 'script',
                    authorizedRole: 'digital_human_list'
                },
                beforeEnter: wrapModelLoaderAsBeforeRouterEnterHook('TextCreate', () =>
                    import('../model/TextCreate')
                ),
                component: importEnv('TextCreate/create/AiContent')
            },
            {
                path: 'title/fc/rewrite',
                name: 'textCreateFcRewrite',
                meta: {
                    source: 'fc',
                    authorizedRole: 'digital_human_list'
                },
                beforeEnter: wrapModelLoaderAsBeforeRouterEnterHook('TextCreate', () =>
                    import('../model/TextCreate')
                ),
                component: importEnv('TextCreate/create/AiContent')
            },
            {
                path: 'title/feed/rewrite',
                name: 'textCreateFeedRewrite',
                meta: {
                    source: 'feed',
                    authorizedRole: 'digital_human_list'
                },
                beforeEnter: wrapModelLoaderAsBeforeRouterEnterHook('TextCreate', () =>
                    import('../model/TextCreate')
                ),
                component: importEnv('TextCreate/create/AiContent')
            },
            {
                path: 'script/rewrite',
                name: 'textCreateScriptRewrite',
                meta: {
                    source: 'script',
                    authorizedRole: 'digital_human_list'
                },
                beforeEnter: wrapModelLoaderAsBeforeRouterEnterHook('TextCreate', () =>
                    import('../model/TextCreate')
                ),
                component: importEnv('TextCreate/create/AiContent')
            },
            // 定义新的路由，保留旧的测试链接自动跳转
            {
                path: 'index',
                redirect: {
                    name: 'textCreateTitleV2'
                }
            }
        ]
    }
];